/*
* @date 2018-04-16
* @author hyt
*/
// 新余额模块
// import Decimal from "decimal.js";
import Decimal from "./../../../utils/Decimal";
import urlParam from './../../../utils/fun.js';
// import CalculateMode from './calculateMode.js'
import payMode from './payMode.js'

var newYue = {
	init: function(showPrices) {
		var html = this.domStr(showPrices);
		html += payMode.payModeDom();
		html += payMode.submitDom();
		$("#prompty_price").html(html);
		// 调用payMode初始化dom事件
		payMode.init();
	},

	// 循环构建业务线推广币dom结构
	// loopWorklineDom: function(list, payLay) {
	// 	var _this = this;
	// 	var arr = [];
	// 	$.each(list, function(index,item) {
	// 		arr.push('\
	// 			<li class="zl_newYe_jimi">\
	// 				<span class="zl_newYe_name">',item.workLine,'：</span>\
	// 				<span class="zl_newYe_price">￥',item.price,'</span>\
	// 				<span class="zl_newYe_total">(共',new Decimal(payLay[index].price).div(10000).toString().match(/\d*\.?\d{0,2}/g)[0],'元可用)</span>');
	// 		if(item.workLine.search("58现金") != -1) {
	// 			arr.push('\
	// 				<span class="zl_newYue_tip"><i>您的推广币不足，我们将自动为您抵扣58现金</i></span>');
	// 		}
	// 		arr.push('\
	// 			</li>');
 //        })
 //        return arr.join('');
	// },

	// 循环各种折扣
	loopDiscounts: function(data) {
		// console.log(data);
		var arr = [];
		$.each(data, function(index, item) {
			if(item.price > 0 && index > 0) {
				arr.push('\
					<li class="zl_newYe_jimi">\
						<span class="zl_newYe_name">',item.name,'：</span>\
						<span class="zl_newYe_price">￥',item.price,'</span>\
					</li>')
			}
		})

		return arr.join('');
	},

	// 构建各种折扣部分的dom结构
	domStr: function(data) {
		// console.log(data)
		// var str = this.loopWorklineDom(data.list, data.payLay);
		// var payLay = data.payLay;
		// var balanceStr;
		// for(var i = 0; i < payLay.length; i++) {
		// 	if((payLay[i].workLine.search("58现金") == -1) && (payLay[i].workLine.search("通用推广币") == -1)) {
		// 		balanceStr = payLay[i].workLine
		// 	}
		// }

		// 循环一遍折扣
		var discountList = this.loopDiscounts(data.discountPrice);
		var dom = `
			<div class="zl_newYe">
				<ul class="zl_newYe_list">
					<li>
						<span class="zl_newYe_name">费用总计：</span>
						<span class="zl_newYe_price">￥${data.hidden_totalPrice}</span>
					</li>
					${discountList}
				</ul>
	            <div class="zl_newYe_payPrice">
                    <span class="zl_newYe_name">实付金额：</span>￥<em>${data.realPrice}</em>
                    <span class="hyt_account_balance">（账户资金${data.accountBalance}元${data.payPrice > 0 ? `，还需充值${data.payPrice}元` : ''}）</span>
                    <div class="zl_autopay_tip">
                        <i class=""></i>
                        <span>账户资金=58现金+通用推广币+${data.businessDescStr}</span>
                    </div>
        		</div>
			</div>`;
		return dom;
	}
}

export default newYue;